<template>
  <div>
    <search v-if="searchDisable !== true" v-model="search" />
    <div
      :class="` position-relative overflow-hidden ${loading ? 'loading' : ''}`"
    >
      <div
        v-if="
          (value.length && !simple) ||
          isAdd ||
          is_filter ||
          isUpdate ||
          setImport === true ||
          (functions && functions.length && value.length)
        "
        class="row mb-2"
      >
        <div class="col-12">
          <ul class="status">
            <li v-if="setImport === true">
              <button
                class="btn btn-sm btn-danger btn-icon mr-2"
                @click="importBillz"
              >
                <span class="ti-download"></span>
                КБ
              </button>
            </li>
            <li v-if="exportFields && Object.keys(exportFields).length">
              <button
                class="btn btn-sm btn-warning btn-icon"
                @click="exportExcel"
              >
                <span class="ti-upload"></span>
                EXCEL
              </button>
            </li>
            <li v-if="isAdd">
              <button
                class="btn btn-info btn-sm btn-icon"
                @click="$modal.show(modalCreate)"
              >
                <span class="ti-plus"></span>
                Добавить
              </button>
            </li>
            <li v-if="is_filter">
              <button class="btn btn-sm btn-icon">
                <span class="ti-filter"></span>
                Фильтровать
              </button>
            </li>

            <li v-for="(m, mKey) in manipulation" :key="mKey">
              <button
                class="btn btn-sm"
                @click="setManipulation(m.key, m.value, m.title)"
              >
                {{ m.title }}
              </button>
            </li>

            <li v-if="isUpdate">
              <button class="btn btn-sm" @click="getList">
                <span class="ti-reload"></span>
              </button>
            </li>

            <li v-if="functions && functions.length && value.length">
              <select
                v-model="funcSelected"
                @change="changeFunction"
                class="btn btn-sm btn-select"
                name=""
                id=""
              >
                <option value="0">Действие</option>
                <option
                  v-for="func in functions"
                  :key="func.id"
                  :value="func.id"
                >
                  {{ func.title }}
                </option>
              </select>
            </li>
            <li v-if="value.length && !simple">
              <button class="btn btn-sm btn-warning btn-icon" @click="val = []">
                <span class="ti-close"></span>
                Сброить {{ value.length }}
              </button>
            </li>
          </ul>
        </div>
      </div>
      <ul v-if="!simple" class="selected-items">
        <li v-for="v in value" :key="v.id">
          <span>{{ v[checkSelect] }}</span>
          <span @click="clearItem(v.id)"> ✕ </span>
        </li>
      </ul>
      <div class="mb-4 text-right">
        <div v-if="items.last_page" class="modal-title badge badge-danger">
          {{
            items.last_page ? "Всего: " + items.total + " шт." : "Загрузка..."
          }}
        </div>
      </div>
      <div class="row" v-if="columns && columns.length && items">
        <div class="col-12">
          <div class="table-full-width table-responsive">
            <paper-table
              v-show="items.data.length"
              type="hover"
              :simple="simple"
              :card="modalCreate"
              :cardLink="cardLink"
              :data="items.data"
              :columns="columns"
              :removeItem="removeItem"
              v-model="val"
              :dataObject="dataObject"
              :current_page="items.current_page"
              @sortby="sortby"
            ></paper-table>
            <h4 v-if="items.data.length === 0">Элементов не найдено</h4>
          </div>
        </div>
      </div>
      <div class="mb-4">
        <h5 v-if="items.last_page" class="modal-title badge badge-danger">
          {{
            items.last_page ? "Всего: " + items.total + " шт." : "Загрузка..."
          }}
        </h5>
      </div>
      <div class="fixed-pagination">
        <div class="responsive-pagination">
          <paginate
            v-if="items.last_page"
            v-show="items.last_page > 1"
            :container-class="'pagination-project'"
            :page-range="3"
            v-model="items.current_page"
            :pageCount="items.last_page"
            :prevText="'Назад'"
            :nextText="'Далее'"
          ></paginate>
        </div>
      </div>
    </div>

    <export-excel
      :exportFields="exportFields"
      :itemLink="itemLink"
      :params="params"
    />

    <add-item
      v-if="isAdd && fields && fields.length && setLink"
      :fieldsFrom="fields"
      :getList="getList"
      :setLink="setLink"
      :params="params"
      :modalCreate="modalCreate"
    />
  </div>
</template>
<script>
import PaperTable from "./PaperTable";
import Search from "./Search";

import { mapState } from "vuex";
export default {
  name: "List",
  data() {
    return {
      sort: {
        orderBy: "id",
        orderType: "DESC",
      },

      dataObject: {},
      funcSelected: 0,
      loading: true,
      loadingSearch: false,
      searcher: null,
      search: "",
      items: {
        last_page: 0,
        current_page: 1,
        total: 0,
        data: [],
      },
    };
  },
  components: {
    PaperTable,
    // AddItem,
    Search,
    "add-item": () => import("./Modals/AddItem"),
    "export-excel": () => import("@/components/ExportExcel"),
  },
  props: {
    value: {
      default: function () {
        return [];
      },
    },
    manipulation: {
      default: function () {
        return [];
      },
    },
    orderBy: {
      default: function () {
        return "id";
      },
    },
    searchDisable: {},
    setLink: {},
    exportFields: {
      default: function () {
        return {};
      },
    },
    itemLink: {
      default: function () {
        return "";
      },
    },
    manipulateLink: {
      default: function () {
        return "";
      },
    },
    title: {},
    simple: {
      default: false,
    },
    setImport: {
      default: false,
    },
    columns: {},
    removeLink: {},
    cardLink: {},
    modalCreate: {},
    disable_add: {},
    is_filter: {},
    isAdd: {},
    isUpdate: {},
    functions: {},
    fields: {},
    params: {
      default: function () {
        return {};
      },
    },
  },
  computed: {
    checkSelect() {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].checkbox === true) {
          return this.columns[i].key;
        }
      }
      return null;
    },
    ...mapState(["newOrder", "lastUpdate"]),
    page() {
      return this.items.current_page;
    },
    val: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    newOrder(val) {
      if (val && this.cardLink === "orders") {
        this.getList(false);
      }
    },
    page(val) {
      if (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.getList();
        }, 100);
      }
    },
    search() {
      this.items.current_page = 1;
      this.loadingSearch = true;
      this.loading = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.getList(false);
      }, 1000);
    },
    lastUpdate(val) {
      if (val) {
        this.getList();
      }
    },
    params: {
      handler: function (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        this.items.current_page = val.page;
        setTimeout(() => {
          this.getList();
        }, 100);
      },
      deep: true,
    },
  },
  methods: {
    setManipulation(key, value, action) {
      this.$dialog
        .confirm(
          `Вы уверены, что правильно отфильтровали (${this.items.total} шт.)  и хотите выполнить "${action}"? `,
          {
            okText: "Выполнить",
            cancelText: "Отмена",
          }
        )
        .then(() => {
          let data = {};
          data[key] = value;
          this.$loading(true);
          this.loading = true;

          this.$http({
            url: this.manipulateLink,
            method: "PUT",
            data: { data: data },
            params: this.params,
          })
            .then((response) => {
              this.$notify({
                title: action,
                message: "Операция успешно выполнена",
                icon: "ti-save",
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
              this.getList();
            })
            .catch((error) => {
              alert("Операция не может быть выполнена");
              return null;
            })
            .finally(() => {
              setTimeout(() => {
                this.$loading(false);
                this.loading = false;
              }, 400);
            });
        })
        .catch(() => {});
    },
    exportExcel() {
      this.$modal.show("export");
    },
    importBillz() {
      this.$loading(true);
      this.$http
        .post("products/exchange")
        .then((response) => {})
        .catch(() => {})
        .finally(() => {
          this.getList();
        });
    },
    changeFunction(val) {
      this.$emit("changeFunction", this.funcSelected);
      this.funcSelected = 0;
    },
    removeItem(itemID) {
      this.$dialog
        .confirm("Вы точно хотите удалить?", {
          okText: "Удалить",
          cancelText: "Отмена",
        })
        .then(() => {
          this.$loading(true);
          this.$http
            .delete(this.removeLink, {
              data: { id: itemID },
            })
            .then((response) => {
              this.getList();
            })
            .catch((error) => {})
            .finally(() => {
              setTimeout(() => {
                this.$loading(false);
              }, 400);
            });
        })
        .catch(() => {});
    },
    getList(loading = true, resetPage = false) {
      let params = this.params ? this.params : {};
      params["page"] = this.items.current_page;
      params["search"] = this.search;
      params["order_by"] = this.sort.orderBy;
      params["order_type"] = this.sort.orderType;

      this.loading = true;
      if (loading) {
        this.$loading(true);
      }
      if (resetPage === true) {
        params["page"] = 1;
      }
      this.$http
        .get(this.itemLink, {
          params: params,
        })
        .then((response) => {
          if (response.data) {
            this.items = response.data;
            if (response.data.data) {
              let data = response.data.data;
              for (let i = 0; i < this.value.length; i++) {
                this.dataObject[this.value[i].id] = this.value[i];
              }
              for (let i = 0; i < data.length; i++) {
                this.dataObject[data[i].id] = data[i];
              }
            }
          }
          if (response.data.type) {
            this.$emit("type", response.data.type);
          }
        })
        .catch(() => {
          this.items.last_page = 1;
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
            this.loading = false;
          }, 400);
        });
    },
    clearItem(id) {
      this.val = [...this.val].filter((item) => {
        return item.id != id;
      });
    },

    sortby(val) {
      this.sort = val;
      this.getList();
    },
  },
  mounted() {
    this.sort.orderBy = this.orderBy;
    this.getList();
  },
};
</script>
<style lang="scss">
ul.selected-items {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  overflow-x: scroll;
  max-width: 100%;
  @media (min-width: 769px) {
    flex-wrap: wrap;
  }

  & > li {
    max-width: 180px;
    border-radius: 5px;
    margin-right: 10px;
    background: #222;
    color: #fff;
    font-size: 10px;
    margin-bottom: 10px;
    padding: 4px 6px;
    display: flex;
    & > span {
      display: block;
      &:last-child {
        font-size: 8px;
        margin-left: 10px;
        cursor: pointer;
        &:hover {
          opacity: 0.6;
        }
      }
    }
  }
}
</style>
